/* eslint-disable no-extra-boolean-cast */
import React, { useEffect, useState, Fragment, useRef } from "react";
import Api from "../../../ApiServices/MasterServices";

import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { accountSchema } from "../../../schemas";
import { FaSpinner } from "react-icons/fa";
import { toast } from "react-toast";
import { Dialog, Combobox, Menu, DialogPanel, DialogTitle, Transition, TransitionChild, Switch } from '@headlessui/react'
import { CheckIcon, XMarkIcon } from '@heroicons/react/24/outline'
import Select from "react-select";
import Editor from '@monaco-editor/react';
import LoadingButton from "../../../components/LoadingButton";

const initialValues = {
  fk_primary_slave_id: "",
  fk_secondary_master_id: "",
  msm_multiplier: "",
  msm_risktype: "", //MASTER
  msm_config: "",
};

const Home = () => {


  const query = new URLSearchParams(window.location.search);
  const slave_id = query.get('acc_id');
  const acc_no = query.get('acc_no');


  const pages = [{ title: "Dashboard", href: "/" }];

  const [acc_id, setAccId] = useState(0);
  const [isSaveBtnApiCall, setIsSaveBtnApiCall] = useState(false);
  const [openAddAccount, setOpenAddAccount] = useState(false);
  const [openAddAccountAcc, setOpenAddAccountAcc] = useState(false);
  const [masterAccounts, setMasterAccount] = useState([]);
  const [masterConnectedAccounts, setMasterConnectedAccount] = useState([]);
  const [slaveAccounts, setSlaveAccount] = useState([]);
  const [formAccount, setFormAccount] = useState(initialValues);
  const [configData, setConfigData] = useState("");
  const editorRef = useRef(null);

  const getSMAcc = async (type) => {
    const getData = await Api.getSlaveMastersAcc(type);
    return getData;
  }

  const setMasterAcc = async () => {
    const resp = await getSMAcc("MASTER");
    if (resp.data.status && resp.data.data.length > 0) {
      setMasterAccount(resp.data.data);
    }
  }

  const setSlaveAcc = async () => {
    const resp = await getSMAcc("SLAVE");
    if (resp.status && resp.data.data.length > 0) {
      setSlaveAccount(resp.data.data);
    }
  }


  useEffect(() => {
    if (Number(slave_id) > 0) {
      (async () => {
        const getResp = await Api.getSlaveMapping(slave_id);
        if (getResp.data.status) {
          setMasterConnectedAccount(getResp.data.data)
        }
        
      })()
      setMasterAcc()
    }
  }, [slave_id]);

  const handleEditGroup = (data) => {
    console.log(data);
    setFormAccount({

    });
    setAccId(data?.acc_id);
    setOpenAddAccount(true);
    if (data?.acc_config != null) {
      setConfigData(JSON.stringify(JSON.parse(data?.acc_config), null, 2));
    }
  }

  /* const handleToggleIsTradeOpen = async (id, status) => {
    console.log({ id, status });
    const payload = { id, status };
    const getResp = await Api.updateAccountInfo(payload);
    if (getResp.data.status) {
      setMasterAcc();
      setSlaveAcc();
    }
  } */

  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      enableReinitialize: true,
      initialValues: formAccount,
      validationSchema: accountSchema,
      onSubmit: async (values, action) => {

        let body = {
          fk_primary_slave_id: Number(slave_id),
          fk_secondary_master_id: Number(values.fk_secondary_master_id),
          msm_multiplier: values.msm_multiplier,
          msm_risktype: values.msm_risktype,
          msm_config: configData,
        };


        const res = await Api.createMasterSlaveMapping(body);

        if (res.data.status) {
          toast.success(res.data.message);
          setMasterAcc();
          setSlaveAcc();
          setOpenAddAccount(false);
          setFormAccount(initialValues);
          setConfigData("");
        } else {
          toast.error(res.data.message);
        }


      },
    });

  const handleEditorDidMount = (editor, monaco) => {
    editorRef.current = editor;
    editor.onDidChangeModelContent(() => {
      setConfigData(editor.getValue());
    });
  }


  return (
    <div>

      {/* sm:grid-cols-2 lg:grid-cols-3 */}
      <div className="grid grid-cols-6 gap-4 pb-4 mb-2">

        {/* COPY FORM */}
        <div className='col-span-6'>
          <div className="overflow-hidden bg-[#151515] shadow sm:rounded-lg mt-5">
            <div className="px-4 py-5 sm:px-6">
              <h3 className="text-ms font-medium leading-6 text-pink-500">Copier Master to Slave (#{acc_no})</h3>
            </div>
            <div className="border-t border-gray-700 px-4 py-5 sm:p-0">

              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  console.log(e);
                  handleSubmit(e);
                }}
                className="flex h-full flex-col"
              >
                <div className="h-0 flex-1 overflow-y-auto">
                  <div className="flex flex-1 flex-col justify-between">
                    <div className="p-4 sm:p-6">

                      <div className="mt-2 mb-2 sm:col-span-2 sm:mt-0">
                        <div>
                          <label
                            htmlFor="acc_type"
                            className="block text-sm font-medium text-gray-200 mt-2 mb-1"
                          >
                            Copy From Account (MASTER)
                          </label>
                        </div>
                        <div className="mt-2 mb-3 sm:col-span-2 sm:mt-0">
                          <select
                            value={values.fk_secondary_master_id}
                            defaultValue={values.fk_secondary_master_id}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="fk_secondary_master_id"
                            className="text-white bg-[#222] block w-full max-w-lg rounded-md border-[1px] p-2 border-gray-800 shadow-sm focus:border-[1px] focus:border-cyan-500 sm:max-w-xs sm:text-sm"
                          >
                            <option disabled>Select Acc Type</option>
                            {masterAccounts.map((data, index) => (
                              <option key={index} value={data.acc_id}>{data.acc_no} - {data.acc_name}</option>
                            ))}
                            {/* <option value="MASTER">MASTER</option>
                                      <option value="SLAVE">SLAVE</option> */}
                          </select>
                          {/* {errors.acc_type && touched.acc_type ? (
																			<p className="text-red-600 text-sm">
																				{errors.acc_type}
																			</p>
																		) : null} */}
                        </div>
                      </div>

                      <div className="mt-2 mb-2 sm:col-span-2 sm:mt-0">
                        <div>
                          <label
                            htmlFor="acc_type"
                            className="block text-sm font-medium text-gray-200 mt-2 mb-1"
                          >
                            Risk Type
                          </label>
                        </div>
                        <div className="mt-2 mb-3 sm:col-span-2 sm:mt-0">
                          <select
                            value={values.msm_risktype}
                            defaultValue={values.msm_risktype}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="msm_risktype"
                            className="text-white bg-[#222] block w-full max-w-lg rounded-md border-[1px] p-2 border-gray-800 shadow-sm focus:border-[1px] focus:border-cyan-500 sm:max-w-xs sm:text-sm"
                          >
                            <option disabled>Select Risk Type</option>
                            <option value="Lot_Multiplier">Lot Multiplier</option>
                            <option value="Risk_Multiplier_By_Balance">Risk Multiplier By Balance</option>
                            <option value="Risk_Multiplier_By_Free_Margin">Risk Multiplier By Free Margin</option>
                            <option value="Exact_Lots">Exact Lots</option>
                          </select>
                          {/* {errors.acc_type && touched.acc_type ? (
																			<p className="text-red-600 text-sm">
																				{errors.acc_type}
																			</p>
																		) : null} */}
                        </div>
                      </div>

                      <div className="mt-2 mb-2 sm:col-span-2 sm:mt-0">
                        <div>
                          <label
                            htmlFor="acc_name"
                            className="block text-sm font-medium text-gray-200 mt-2 mb-1"
                          >
                            Multiplier
                          </label>
                        </div>
                        <div className="mt-2 mb-3 sm:col-span-2 sm:mt-0">
                          <input
                            value={values.msm_multiplier}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            type="number"
                            placeholder="Multiplier"
                            name="msm_multiplier"
                            autoComplete="off"
                            step={0.1}
                            className="text-white bg-[#222] block w-full max-w-lg rounded-md border-[1px] p-2 border-gray-800 shadow-sm focus:border-[1px] focus:border-cyan-500 sm:max-w-xs sm:text-sm"
                          />
                          {/* {errors.acc_name &&
																			touched.acc_name ? (
																			<p className="text-red-600 text-sm">
																				{errors.acc_name}
																			</p>
																		) : null} */}
                        </div>
                      </div>


                      {/* <div className="mt-2 mb-2 sm:col-span-2 sm:mt-0">
                        <div>
                          <label
                            className="block text-sm font-medium text-gray-900 mt-2"
                          >
                            Config Data - (JSON/TEXT)
                          </label>
                        </div>
                        <div className="mb-3 sm:col-span-2 sm:mt-0">

                          <Editor
                            height="30vh"
                            defaultLanguage="json"
                            defaultValue={configData}
                            onMount={handleEditorDidMount}
                            className="border bg-slate-400"
                          />
                        </div>
                      </div> */}

                    </div>
                  </div>
                </div>
                <div className="flex flex-shrink-0 justify-end px-4 pb-2">
                  <button
                    type="button"
                    className="rounded-md border border-gray-800 bg-[#222] py-2 px-4 text-sm font-medium text-gray-200 shadow-sm"
                    onClick={() => {
                      setFormAccount({
                        fk_primary_slave_id: "",
                        fk_secondary_master_id: "",
                        msm_multiplier: "",
                        msm_risktype: "",
                        msm_config: "",
                      });
                      setAccId(null);
                      setConfigData("");
                      setOpenAddAccount(false);
                    }}
                  >
                    Cancel
                  </button>
                  {
                    isSaveBtnApiCall ? (
                      <LoadingButton title=" Saving" />
                    ) : (
                      <button
                        type="submit"
                        className="ml-4 inline-flex justify-center rounded-md bbt bg-gradient-to-b bg-[#0172fd] py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-cyan-700"
                      >
                        {acc_id > 0 ? 'Update' : 'Create Copier'}
                      </button>
                    )
                  }
                </div>
              </form>

            </div>
          </div>
        </div>


        {/* CONNECTED to Masters */}
        <div className='col-span-6'>
          <div className="overflow-hidden bg-[#151515] shadow sm:rounded-lg mt-5">
            <div className="px-4 py-5 sm:px-6">
              <h3 className="text-ms font-medium leading-6 text-pink-500">Slave Account Conneted To Master(s) </h3>
            </div>
            <div className="border-t border-gray-800 px-4 py-5 sm:p-0">

              <div className="overflow-hidden shadow ring-1 ring-black/5">
                <table className="min-w-full divide-y divide-gray-800">
                  <thead className="bg-gray-500">
                    <tr>
                      <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                        Account No
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        Name
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        Suffix
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        Is Trade Open
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        Is Banned
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-gray-900">

                    {masterConnectedAccounts.map((acc, index) => (
                      <tr key={index}>
                        <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-300 sm:pl-6">
                          {acc?.master_fk_relation?.acc_no || "-"}
                        </td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-300">{acc?.master_fk_relation?.acc_name || "-"}</td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-300">{acc?.master_fk_relation?.acc_suffix || "-"}</td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-300">{acc?.master_fk_relation?.acc_copy_close_trades ? "YES" : "NO"}</td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-300">{acc?.master_fk_relation?.acc_is_banned ? "BANNED" : "ACTIVE"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

            </div>
          </div>
        </div>

      </div>



    </div>
  )

}

export default Home